// extracted by mini-css-extract-plugin
export default {"header":"PU-z","logo":"QU-z","signin":"RU-z"};